import { render, staticRenderFns } from "./Trip.vue?vue&type=template&id=2d1eb432"
import script from "./Trip.vue?vue&type=script&lang=js"
export * from "./Trip.vue?vue&type=script&lang=js"
import style0 from "./Trip.vue?vue&type=style&index=0&id=2d1eb432&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports